import(/* webpackMode: "eager" */ "/app/src/app/goc-chia-se-kinh-nghiem/[post]/page.js");
